import { StatusMessageResponse } from '@shared/models';

export interface SimplePatientsResponse extends StatusMessageResponse {
  patient_list: SimplePatient[];
}

export interface SimplePatient {
  patient_id:number;
  id: number;
  fullname: string;
  id_number?: number | string | null;
  date_birth:string;
  age?:number;
}
